export const getTelegramWebApp = () =>
  typeof window !== "undefined" ? window.Telegram?.WebApp : undefined;

const fallbackHaptic = {
  impactOccurred: () => undefined,
  notificationOccurred: () => undefined,
  selectionChanged: () => undefined,
};

// Fallback object keeps app stable when WebApp API is not available.
export const tg: any = {
  HapticFeedback: fallbackHaptic,
  ready: () => undefined,
  close: () => undefined,
  expand: () => undefined,
  requestFullscreen: () => undefined,
  enableClosingConfirmation: () => undefined,
  setHeaderColor: () => undefined,
  setBackgroundColor: () => undefined,
  sendData: () => undefined,
  get initData() {
    return getTelegramWebApp()?.initData;
  },
  get platform() {
    return getTelegramWebApp()?.platform;
  },
};
